import React, { useEffect, useRef, useState } from "react";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { StyledButton } from "../../components/styledComponent/styledElements";
import CustomTable from "../../components/styledComponent/styledTable";
import { AiOutlinePlusSquare } from "react-icons/ai";
import {
  createCategory,
  deleteCategory,
  listAllCategories,
  updateCategory,
} from "../../server/categoryServices";
import { ShowNotification } from "../../components/notification/notification";
import TableActions from "../../components/tableAction/tableActions";
import CategoryCreationModal from "./categoryCreationModal";
import DeleteModal from "../../components/styledComponent/deleteModal";
import { useAppContext } from "../../contexts/appContext";
import { useNavigate } from "react-router-dom";

function CategoryPage() {
  const column = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Name in Arabic",
      dataIndex: "name_arabic",
      key: "name_arabic",
    },
    {
      title: "Parent ID",
      dataIndex: "parent_id",
      key: "parentId",
    },
    {
      key: "actions",
      width: 100,
      render: (text, record) => (
        <TableActions
          showDelete={userRole === "Admin" || categoryAccess?.delete}
          showEdit={userRole === "Admin" || categoryAccess?.edit}
          onClickDelete={() => {
            setDeleteId(record.id);
            setShowDeletePopup(true);
          }}
          onClickEdit={() => {
            setAddCategoryModal(true);
            setUpdate(record);
          }}
        />
      ),
    },
  ];
  const formRef = useRef();
  const navigate = useNavigate();
  const { startLoading, stopLoading, user } = useAppContext();

  const [update, setUpdate] = useState(null);
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [refetch, setRefetch] = useState(false);
  var userRole = user?.role;
  var categoryAccess = user?.access?.category;

  const fetchCategories = async () => {
    try {
      startLoading();
      const categories = await listAllCategories();
      setTableData(categories.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    fetchCategories();
    setRefetch(false);
  }, [refetch]);

  const handleAddCategory = (values) => {
    startLoading();
    createCategory(values)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Category Successfully Added",
        });
        setAddCategoryModal(false);
        setRefetch(true);
      })
      .finally(() => {
        stopLoading();
        formRef.current.resetFields();
      });
  };
  const handleUpdateCategory = (values) => {
    startLoading();
    updateCategory(update.id, values)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Category Updated Successfully",
        });
        setAddCategoryModal(false);
        setRefetch(true);
      })
      .finally(() => {
        formRef.current.resetFields();
        stopLoading();
        setUpdate(null);
      });
  };
  const handleDeleteCategory = () => {
    deleteCategory(deleteId)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Category Deleted Successfully ",
        });
        setRefetch(true);
      })
      .finally(() => {
        setDeleteId(null);
        setShowDeletePopup(false);
      });
  };
  return (
    <div>
      <StyledContentCard title={"Category"}>
        <div className="flex float-right mb-2 gap-2">
          {(userRole === "Admin" || categoryAccess?.create) && (
            <StyledButton
              icon={<AiOutlinePlusSquare size={20} />}
              iconPosition="start"
              onClick={() => setAddCategoryModal(true)}
            >
              Category
            </StyledButton>
          )}
        </div>
        {addCategoryModal && (
          <CategoryCreationModal
            showCreationModal={addCategoryModal}
            setShowCreationModal={setAddCategoryModal}
            onSubmit={handleAddCategory}
            formRef={formRef}
            update={update}
            setUpdate={setUpdate}
            onUpdate={handleUpdateCategory}
          />
        )}
        {showDeletePopup && (
          <DeleteModal
            showDelete={showDeletePopup}
            onCancel={() => {
              setDeleteId(null);
              setShowDeletePopup(false);
            }}
            onsubmit={handleDeleteCategory}
          />
        )}
        <CustomTable
          data={tableData}
          columns={column}
          rowKey="id"
          onRow={(record) => {
            return {
              onClick: () => {
                navigate(`/category/${record.id}`);
              },
              className: "clickable",
            };
          }}
        />
      </StyledContentCard>
    </div>
  );
}

export default CategoryPage;
